/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S4_P1_BeforeInputs */

const tr_hakkimizda_s4_p1_before = /** @type {(inputs: Hakkimizda_S4_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ platformu`)
};

const en_hakkimizda_s4_p1_before = /** @type {(inputs: Hakkimizda_S4_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ShopPanel™ platform is operated by`)
};

const de_hakkimizda_s4_p1_before = /** @type {(inputs: Hakkimizda_S4_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Plattform ShopPanel™ wird von`)
};

const ru_hakkimizda_s4_p1_before = /** @type {(inputs: Hakkimizda_S4_P1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа ShopPanel™ управляется компанией`)
};

/**
* | output |
* | --- |
* | "The ShopPanel™ platform is operated by" |
*
* @param {Hakkimizda_S4_P1_BeforeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s4_p1_before = /** @type {((inputs?: Hakkimizda_S4_P1_BeforeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S4_P1_BeforeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s4_p1_before(inputs)
	if (locale === "de") return de_hakkimizda_s4_p1_before(inputs)
	if (locale === "ru") return ru_hakkimizda_s4_p1_before(inputs)
	return tr_hakkimizda_s4_p1_before(inputs)
});